// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3_3sZ","footer":"ChangeClinic_footer__1266G"};